// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.2-TSS-3015-mcastro-FEATURE-Display-New-Columns-from-QMS-Data-Dump.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
